import { normalizePersianText } from './persian-text.js'; // eslint-disable-line import/extensions

export function normalizeDigits(value = '') {
  const persian = '۰۱۲۳۴۵۶۷۸۹';
  const arabic = '٠١٢٣٤٥٦٧٨٩';
  return String(value)
    .replace(/[۰-۹]/g, (character) => String(persian.indexOf(character)))
    .replace(/[٠-٩]/g, (character) => String(arabic.indexOf(character)));
}

export function toPersianDigits(value = '') {
  return normalizeDigits(value).replace(/[0-9]/g, (digit) =>
    String.fromCharCode(1776 + Number(digit))
  );
}

export function isValidEmail(value = '') {
  const normalized = String(value).trim();
  return normalized.length <= 320 && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u.test(normalized);
}

export function normalizeIranianMobile(value = '') {
  const digits = normalizeDigits(value).replace(/\D/g, '');
  if (digits.startsWith('0098')) return `0${digits.slice(4)}`;
  if (digits.startsWith('98')) return `0${digits.slice(2)}`;
  return digits;
}

export function isValidIranianMobile(value = '') {
  return /^09\d{9}$/.test(normalizeIranianMobile(value));
}

const IRANIAN_PLATE_LETTERS = 'آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی';
const MOTORCYCLE_PLATE_TYPES = new Set(['Motorcycle', 'Scooter', 'Moped', 'ThreeWheeler', 'ATV']);

export function usesMotorcyclePlate(vehicleType = '') {
  return MOTORCYCLE_PLATE_TYPES.has(vehicleType);
}

function compactIranianPlate(value = '') {
  return normalizePersianText(normalizeDigits(value))
    .trim()
    .replace(/ایران/gu, '')
    .replace(/[\s\-–—]+/gu, '');
}

export function isValidIranianPlate(value = '', vehicleType = '') {
  const compact = compactIranianPlate(value);
  if (!compact) return true;
  if (!vehicleType) return false;
  if (usesMotorcyclePlate(vehicleType)) return /^\d{8}$/.test(compact);

  return new RegExp(`^\\d{2}[${IRANIAN_PLATE_LETTERS}]\\d{5}$`, 'u').test(compact);
}

export function normalizeIranianPlate(value = '', vehicleType = '') {
  const compact = compactIranianPlate(value);
  if (!compact) return '';
  if (!isValidIranianPlate(value, vehicleType)) return String(value).trim();
  if (usesMotorcyclePlate(vehicleType)) return `${compact.slice(0, 3)} - ${compact.slice(3)}`;

  return `${compact.slice(0, 2)} ${compact[2]} ${compact.slice(3, 6)} ایران ${compact.slice(6)}`;
}

export function isValidIranianNationalCode(value = '') {
  const digits = normalizeDigits(value).replace(/\D/g, '');
  if (!/^\d{10}$/.test(digits) || /^(\d)\1{9}$/.test(digits)) return false;
  const sum = digits
    .slice(0, 9)
    .split('')
    .reduce((total, digit, index) => total + Number(digit) * (10 - index), 0);
  const remainder = sum % 11;
  return Number(digits[9]) === (remainder < 2 ? remainder : 11 - remainder);
}

export function isValidLoginIdentifier(value = '') {
  const normalized = String(value).trim();
  if (!normalized) return false;
  if (normalized.includes('@')) return isValidEmail(normalized);
  if (/^[+۰-۹٠-٩\d\s()-]+$/u.test(normalized)) return isValidIranianMobile(normalized);
  return /^[\p{L}\p{N}._-]{3,64}$/u.test(normalized);
}

export function passwordRequirementMessages(policy) {
  return [
    `حداقل ${policy?.passwordMinimumLength || 12} نویسه`,
    policy?.passwordRequireLetter !== false && 'حداقل یک حرف',
    policy?.passwordRequireNumber !== false && 'حداقل یک عدد',
    policy?.passwordRequireSymbol !== false && 'حداقل یک نماد',
  ].filter(Boolean);
}
